"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var Icon_1 = require("../../Icon");
var propTypes = {
    searchPlaceholder: PropTypes.string.isRequired,
    searchFunction: PropTypes.func.isRequired,
};
var BasicSearchFilter = function (_a) {
    var searchPlaceholder = _a.searchPlaceholder, searchFunction = _a.searchFunction;
    var _b = React.useState(''), searchValue = _b[0], setSearchValue = _b[1];
    var _c = React.useState(''), lastSearchValue = _c[0], setLastSearchValue = _c[1];
    var updateSearchField = React.useCallback(function (e) { return setSearchValue(e.target.value); }, []);
    var handleSearch = React.useCallback(function (searchStr) {
        searchFunction({ searchTerm: searchStr });
        setLastSearchValue(searchStr);
    }, []);
    var searchAction = React.useCallback(function () {
        handleSearch(searchValue);
    }, [searchValue]);
    var clearAction = React.useCallback(function () {
        setSearchValue('');
        handleSearch('');
    }, []);
    var handleSearchKeyPress = React.useCallback(function (e) {
        if (e.key === 'Enter') {
            searchAction();
        }
    }, [searchValue]);
    var showClear = lastSearchValue === searchValue && searchValue !== '';
    return (React.createElement("div", { className: "InputGroup InputGroup--leftIcon InputGroup--iconButton", style: { width: '100%' } },
        React.createElement("input", { value: searchValue, name: "searchField", className: "BasicSearch Input Grid-cell", placeholder: searchPlaceholder, onChange: updateSearchField, onKeyPress: handleSearchKeyPress, style: { minWidth: 250 } }),
        React.createElement("button", { type: "submit", className: "InputGroup-icon", onClick: showClear ? clearAction : searchAction },
            React.createElement(Icon_1.Icon, { className: "Icon", mods: null, name: showClear ? 'dismiss' : 'search', otherProps: {}, style: {} }))));
};
exports.default = BasicSearchFilter;
